import Textarea from './textarea.element.js';

export default Textarea;

Textarea.define('wje-textarea', Textarea);
